export function isMobileApp() {
    return window.location.href.startsWith("capacit")
}
